<div data-cy="nenhum_resultado" class="text-center">
    <img src="assets/images/nenhum_resultado.png" alt="Nenhum resultado encontrado" />
    <p class="text-up-03 text-mint-cool-vivid-40 text-weight-semi-bold" data-cy="titulo-nenhum-resultado">Não encontramos o que você procura!</p>
    <p data-cy="mensagem-nenhum-resultado">Refine sua pesquisa configurando os parâmetros de filtros logo acima e tente novamente.</p>
</div>
